export const NEW_CLOUD_SITE = 'NEW SITE';
export const NEW_CLOUD_SITE_ID = 'new-site';

export const CART_ROUTE_PARAMS = {
  CUSTOMER: 'customer',
  BILLING_PROFILE: 'billingProfile',
};
